import api from '../../tools/api-tools'
import resUrl from './resource-url'
import { mainWeb, mainWebPostData } from '../../config/net'
import Goods from '../goods'
import device from '../../tools/device'

class ValueAddedService {
  constructor () {
    // 默认是不能买
    this.IsCanBuyAdvance = 1
    // 默认不能卖
    this.canBuyProfession = false
    // 1代表可以买
    this.canBuy = 1
    // 错误提示
    this.errorMess = ''
    this.version = ''
  }

  loadData () {
    return new Promise((resolve, reject) => {
      api.get(resUrl.banners).then(async (res) => {
        let data = res.data.data || {}
        let banner = []
        let panelItems = [{
          title: '',
          items: [
          //   {
          //   id: Goods.saas.miniApp.id,
          //   img: require('@/assets/images/value-added-service/mini-logo.png'),
          //   title: '小程序',
          //   desc: '10秒创建商城，连接9亿微信流量',
          //   price: '&yen;999/年'
          // },
          //  {
          //   id: Goods.saas.newRetail.id,
          //   img: require('@/assets/images/value-added-service/new-retail.png'),
          //   title: '客无忧营销套餐',
          //   desc: '完整高效的一体化经营方案',
          //   price: '&yen;2388/年'
          // },
            {
              id: Goods.saas.wxCardAdvanced.id,
              img: require('@/assets/images/value-added-service/wx-card@2x.png'),
              title: '微信营销·至尊版',
              desc: '1天增加500会员，销售额爆破式增长',
              price: '&yen;999/年'
            },
          // {
          //   id: Goods.saas.wechatCard.id,
          //   img: require('@/assets/images/value-added-service/vip-card@2x.png'),
          //   title: '微信会员卡',
          //   desc: '用微信的人，都有你的会员卡',
          //   price: '&yen;288/年'
          // },
            {
              id: Goods.saas.mobileMessage.id,
              img: require('@/assets/images/value-added-service/message@2x.png'),
              title: '短信包',
              desc: '1069通道，保证98%到达率',
              price: '&yen;0.06/条起'
            }, {
              id: Goods.saas.mobilePay.id,
              img: require('@/assets/images/value-added-service/mobile-pay@2x.png'),
              title: '移动收款',
              desc: '支付宝+微信：灵活收钱，速度更快',
              price: '&yen;0/年'
            }, {
              id: Goods.saas.marterial.id,
              img: require('@/assets/images/value-added-service/mall-material@2x.png'),
              title: '收款物料（暂时缺货）',
              desc: '张贴精美物料，获更多客流',
              price: '&yen;3/份'
            }]
        }
          // {
          //   title: '用户福利 低价充值',
          //   items: [
          //     {
          //       id: 0,
          //       img: require('@/assets/images/value-added-service/recharge@2x.png'),
          //       title: '充值中心',
          //       desc: '闪电到账，方便快捷',
          //       price: '&yen;98.8起'// 98.8起
          //     }
          //   ]
          // }
        ]
        if ('items' in data) {
          for (let item of data.items) {
            let nowLink = this._getTurl(item.link)
            banner.push({
              image: item.image,
              link: nowLink
            })
          }
        }
        this.version = await this.getReleaseVersion()
        // 审核版本移除对象
        let auditGoodsItem = [Goods.saas.miniApp.id, Goods.saas.newRetail.id, Goods.saas.wxCardAdvanced.id, Goods.saas.mobileMessage.id, Goods.saas.shopWindow.id, Goods.saas.wechatCard.id]
        let panelItemsArr = panelItems[0].items.map(cItem => {
          if (!auditGoodsItem.includes(cItem.id)) return cItem
        }).filter(res => {
          return res
        })
        // 为IOS审核提供（隐藏部分增值业务）
        if (device.ios && (window.localStorage && (window.localStorage.getItem('version').toString() >= this.version.toString()))) {
          panelItems[0].items = panelItemsArr
        }
        resolve({ banner, panelItems })
      }).catch(e => {
        reject(e)
      })
    })
  }

  getReleaseVersion () {
    return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/ios/version/beforeRelease`).then(res => {
      return res.data.version || ''
    })
  }

  _getTurl (link) {
    let turl = link.indexOf('turl=') > 0 ? link.substring(link.indexOf('turl=') + 5) : ''
    return JSON.parse(turl.length ? decodeURIComponent(turl).replace(/###/g, '') : '{}')
  }

  loadDetail (id) {
    id = Number(id)
    let _that = this
    return api.post(resUrl.detail.url, mainWebPostData(resUrl.detail.method, {
      goodsId: id,
      goodsType: '1'
    })).then(res => {
      let model = JSON.parse(res.data.Model || '{}')
      _that.canBuy = model.CanBuy
      _that.errorMess = model.ErrorMessage
      let images = []
      let listPic = model['ListPic'] || []
      for (let item of listPic) {
        images.push(`${mainWeb}${item.PicUrl}`)
      }
      let panelItems = []
      if (model.ShowTopBanner === 1) {
        panelItems = [{
          img: `${mainWeb}${model.ProductIcon}`,
          title: model.ProductName,
          desc: model.ProductDesc,
          price: model.ProductBasePrice,
          oriPrice: model.OriginalPrice
        }]
      }
      /*
      if (id !== Goods.saas.professionClothing.id) {
        panelItems = [{
          img: `${mainWeb}${model.ProductIcon}`,
          title: model.ProductName,
          desc: model.ProductDesc,
          price: model.ProductBasePrice,
          oriPrice: model.OriginalPrice
        }]
      }
      */
      return {
        images,
        panelItems
      }
    }).catch(e => {
      return e
    })
  }

  // 是否可以买
  isCanBuy () {
    return this.canBuy === 1
  }

  // 获取错误信息
  getErrorMess () {
    return this.errorMess || '当前不能购买'
  }

  isProfessionCanBuy () {
    return api.post(resUrl.professionId.url, mainWebPostData(resUrl.professionId.method, {})).then(res => {
      let data = res.data || {}
      return data
    })
  }

  // 获取商品详情（积分）
  getUserInfo (goodsId, remark = 0, goodsType = 1) {
    let payObj = { goodsId: goodsId, goodsType: goodsType, quantity: 1, couponCode: '', remark: remark }
    return api.post(resUrl.mainWebUrl, mainWebPostData('businfo', payObj)).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    }).catch(e => {
      console.log(e)
    })
  }

  // 获取终身版本购买信息，双11使用
  getVersionBuyInfo () {
    return api.post(resUrl.versionBuyInfo.url, mainWebPostData(resUrl.versionBuyInfo.method, {})).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    })
  }

  // 获取终身版本购买信息，双11使用
  getVersionBuyInfo2018 () {
    return api.post(resUrl.versionBuyInfo.url, mainWebPostData(resUrl.versionBuyInfo2018.method, {})).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    })
  }
  /* =====================================2019-03-08女神节活动使用=========================================================== */
  /**
   * 获取当前用户所有的版本信息
   * 2019-03-07
   */
  getCurrentVersionInfo0308 () {
    return api.post(resUrl.version20190308.url, mainWebPostData(resUrl.version20190308.method, {})).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      // mock
      // var obj = {
      //   'TargetGroupId': 6404,
      //   'AccountInfo': {
      //     'Version': 5,
      //     'BetaAdvance': 3,
      //     'IndustryId': 15,
      //     'IndustryName': '美业',
      //     'VersionExpirationTime': '2052-02-12T11:10:49.103',
      //     'LongLifeStatus': 0
      //   },
      //   'ReceivedGroupId': 0
      // }
      return model
    })
  }
  /**
   * 获取当前用户可以领取的优惠券
   */
  getReceiveCoupon0308 () {
    return api.post(resUrl.receivecoupon20190308.url, mainWebPostData(resUrl.receivecoupon20190308.method, {})).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    })
  }
  /* =====================================2019-11-11活动使用=========================================================== */
  getCurrentVersionInfo20191111 () {
    return api.post(resUrl.version20191111.url, mainWebPostData(resUrl.version20191111.method, {})).then(res => {
      let model = JSON.parse(res.data.Model) || {}
      return model
    })
  }
}

export default ValueAddedService



// WEBPACK FOOTER //
// ./src/model/value-added-service/index.js